import {
  LoadInvoicesRequestAction,
  LoadInvoicesSuccessAction,
  LoadInvoicesErrorAction,
  ClearStoreAction,
} from './actions.d';
import actionsTypes from './actionTypes';
import { ILoadDataRequestPayload, ILoadDataSuccessPayload } from './types.d';

const actions = {
  loadInvoicesRequest: <T1, T2>(payload: ILoadDataRequestPayload<T1, T2>): LoadInvoicesRequestAction<T1, T2> => ({
    type: actionsTypes.LOAD_INVOICES_REQUEST,
    payload,
  }),

  loadInvoicesSuccess: (payload: ILoadDataSuccessPayload): LoadInvoicesSuccessAction => ({
    type: actionsTypes.LOAD_INVOICES_SUCCESS,
    payload,
  }),

  loadInvoicesError: (): LoadInvoicesErrorAction => ({
    type: actionsTypes.LOAD_INVOICES_ERROR,
  }),

  clearStore: (): ClearStoreAction => ({
    type: actionsTypes.CLEAR_STORE,
  }),
};

export default actions;
